import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Footer from './Footer';
import AppBanner from './AppBanner';

// eslint-disable-next-line func-names
const UmnHeader = function (props) {
  const { mainNavId, mainContentId, appTitle } = props;
  return (
    <Header
      mainNavId={mainNavId}
      mainContentId={mainContentId}
      appTitle={appTitle}
    />
  );
};
// UmnHeader.propTypes = {
//   mainNavId: PropTypes.string,
//   mainContentId: PropTypes.string,
//   appTitle: PropTypes.string,
// };
// UmnHeader.defaultProps = {
//   mainNavId: undefined,
//   mainContentId: undefined,
//   appTitle: undefined,
// };

/* *********************************************************************************************************** */
// eslint-disable-next-line func-names
const UmnFooter = function (props) {
  const { year } = props;
  return <Footer year={year} />;
};

// UmnFooter.propTypes = {
//   year: PropTypes.string,
// };
// UmnFooter.defaultProps = {
//   year: undefined,
// };

/* *********************************************************************************************************** */
// eslint-disable-next-line func-names
const UmnAppBanner = function (props) {
  const { appTitle } = props;
  return <AppBanner appTitle={appTitle} />;
};

UmnHeader.propTypes = {
  appTitle: PropTypes.string.isRequired,
  mainNavId: PropTypes.string.isRequired,
  mainContentId: PropTypes.string.isRequired,
};

UmnFooter.propTypes = {
  year: PropTypes.number.isRequired,
};

UmnAppBanner.propTypes = {
  appTitle: PropTypes.string.isRequired,
};

export { UmnHeader, UmnFooter, UmnAppBanner };
